import ArticleIcon from "../icon-components/ArticleIcon";
import URLIcon from "../icon-components/URLIcon";
import VideoPlayIcon from "../icon-components/VideoPlayIcon";

interface DynamicContentIconsProps {
  type: string;
  height?: string;
  width?: string;
  color?: string;
}
const DynamicContentIcons = ({
  type,
  height,
  width,
  color,
}: DynamicContentIconsProps) => {
  if (!type) {
    return null; // Handle undefined or null type
  }
  switch (type) {
    case "videos":
      return <VideoPlayIcon height={height} width={width} color={color} />;
    case "articles":
      return <ArticleIcon height={height} width={width} color={color} />;
    case "URL":
      return <URLIcon height={height} width={width} color={color} />;
    default:
      return null; // Return null if no valid type is provided
  }
};

export default DynamicContentIcons;
